// extracted by mini-css-extract-plugin
module.exports = {"fixedContainer":"FixedContainer_fixedContainer__31H6Y","fixed":"FixedContainer_fixed__3gCsc"};